import { fetchGet } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';

export default async (taskId: number) => {
    const result = await fetchGet(`${nodePath}/user-stories/info?taskId=${taskId}`);

    return result;
};
